export class User {
    ID: string;
    client_ID: string;
    user_ID: string;
    username: string;
    email: string;
    first_name: string;
    last_name: string;
    title: string;
    profile: string;
    json_custom_fields: string;
    session_token: string;
    session_token_ttl: string;
    expire_in: string;
    time_zone: string;
    home_page: string;
    team_role: string;
    administrator_level: string;
    team_name: string;
    client_code: string;
    logout_url: string;
    sso_signout_url: string;
    sso_signin_url: string;
    team_key_ID: string;
    team_ID: string;
    store: string;
    // customer_user: any;
    // customer_related_Item: any;
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/user.model.ts